import { Component, OnInit } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2';
import { lang_generic } from 'app/idiomas/i18n/survey-generic/generic.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
// import { ConsultaEncuestaService } from "./consulta-encuesta.service";
import { ODSService } from "app/main/pagina/tools/gestUsu/services/ods.service";
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-survey-generic',
  templateUrl: './survey-generic.component.html',
  styleUrls: ['./survey-generic.component.scss'],
  animations   : fuseAnimations
})
export class SurveyGenericComponent implements OnInit {
idiomaActual: string;
tokenConfig: string;
reportSurveyGeneric:any;
busquedaIniciada:boolean;
buscando: boolean;
  constructor(
      private _fuseTranslationLoaderService: FuseTranslationLoaderService,
      // private servicio: ConsultaEncuestaService,
      private odsService: ODSService,
      private translateSrv: TranslateService,) {
        this.idiomaActual = this.translateSrv.currentLang;
        lang_generic.forEach((locale) => {
          this._fuseTranslationLoaderService.loadTranslations(locale);
        });
       }

  ngOnInit(): void {
  }

  consultSurveyGeneric(){
    if (this.tokenConfig!="") {
      this.busquedaIniciada = true;
      this.buscando = true;
      this.odsService.getReportSurveyGeneric(this.tokenConfig).subscribe((response: any) => {
        console.log("Report tokenConfig::::::",response);
        this.reportSurveyGeneric=response.usuarios;
        this.buscando = false;
      }, error => {
        console.log("error", error);
      });

    }
  }

  descargarResultados(){
    // Swal.showLoading()
    var wb = XLSX.utils.book_new();
    wb.Props = {
      Title: 'Reporte encuesta generica',
      Subject: 'CULTURAL GO',
      Author: 'ITBM',
      CreatedDate: new Date()
    };
    wb.SheetNames.push('hoja');
    var ws_data = [];
    let nombresColumnas:string[] = [];

    for (let clave in this.reportSurveyGeneric[0]) {
      console.log('clave',clave);
      if(clave=='__v') {
      }else if(clave=='_id') {
      } else {
        nombresColumnas.push(clave);
      }
    }

    ws_data.push(nombresColumnas);
    this.reportSurveyGeneric.forEach( (info) => {
      let datosEncuestas:any[] = [];
      nombresColumnas.forEach( (nombre) => {
        if (nombre=="company") {
          datosEncuestas.push(info.company.nombre);
        }else{
          datosEncuestas.push(info[nombre]);
        }
      });
      ws_data.push(datosEncuestas);
    });
    var ws = XLSX.utils.aoa_to_sheet(ws_data);
    wb.Sheets['hoja'] = ws;
    var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
    var buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
    var view = new Uint8Array(buf);  //create uint8array as viewer
    for (var i=0; i<wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet
    // saveAs(new Blob([buf],{type:"application/octet-stream"}), `${this.translateSrv.instant("COLABORADORES.EXCEL.TITUARCHIVO")}.xlsx`);
    saveAs(new Blob([buf],{type:"application/octet-stream"}), `${'Reporte encuestas genericas'}.xlsx`);
    // Swal.close();
  }

}
